import { render, staticRenderFns } from "./montFoot.vue?vue&type=template&id=a600d448&scoped=true"
import script from "./montFoot.vue?vue&type=script&lang=js"
export * from "./montFoot.vue?vue&type=script&lang=js"
import style0 from "./montFoot.vue?vue&type=style&index=0&id=a600d448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a600d448",
  null
  
)

export default component.exports